import { render } from "./IfuWip.vue?vue&type=template&id=2598461d&scoped=true"
import script from "./IfuWip.vue?vue&type=script&lang=js"
export * from "./IfuWip.vue?vue&type=script&lang=js"

import "./IfuWip.vue?vue&type=style&index=0&id=2598461d&scoped=true&lang=scss"

import exportComponent from "/Users/skynet/Documents/Sites Safe OK MAIS PEUT ETRE PAS A JOUR/Safe_Sites_Modifs/SAFE_ORTHO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2598461d"]])

export default __exports__